import { Helmet } from "react-helmet";
import Banner from "../components/Banner";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";
import Section5 from "./Sections/Section5";
import Section6 from "./Sections/Section6";
import Section7 from "./Sections/Section7";
import Section8 from "./Sections/Section8";
import Section9 from "./Sections/Section9";
import Section10 from "./Sections/Section10";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>
          Buy Servers, PCs & Networking Equipment Online | Server Stock UK
        </title>
        {/* <meta
          name="description"
          content="Server Stock UK offers high-quality servers, PCs, laptops, and networking hardware for businesses and home users across the UK and Europe. Shop top IT products online today."
        /> */}
        <meta
          name="description"
          content="Buy Memory and Storage Devices - Hard Disk Drive Online Store"
        />
        <link rel="canonical" href="https://www.serverstock.co.uk/" />
      </Helmet>
      <Banner />
      <Section1 />
      <Section7 />
      <Section10 />

      <Section8 />
      <Section2 />

      <Section9 />
      <Section6 />

      <Section5 />
    </>
  );
}
